import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialLightBulb: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M27.43 6.1h1.52v12.19h-1.52ZM25.9 18.29h1.53v1.52H25.9Zm0-13.72h1.53V6.1H25.9Zm-1.52 15.24h1.52v1.52h-1.52Zm0-16.76h1.52v1.52h-1.52Zm-1.53 18.28h1.53v1.53h-1.53Zm0-19.81h1.53v1.53h-1.53Zm-4.57 21.34v-6.1h-1.52v6.1h-1.52v-6.1h-1.53v6.1H9.14v1.52h1.52v6.1h1.53v-1.53h7.62v1.53h1.52v-6.1h1.52v-1.52Zm1.53 3.04h-7.62v-1.52h7.62Zm0-15.23h1.52v3.04h-1.52Z\"/><path fill=\"currentColor\" d=\"M18.28 13.71h1.53v3.05h-1.53Zm-6.09 16.77h7.62V32h-7.62Zm0-16.77h1.52v3.05h-1.52Zm-1.53-3.04h1.53v3.04h-1.53ZM9.14 0h13.71v1.52H9.14ZM7.62 21.33h1.52v1.53H7.62Zm0-19.81h1.52v1.53H7.62ZM6.09 19.81h1.53v1.52H6.09Zm0-16.76h1.53v1.52H6.09ZM4.57 18.29h1.52v1.52H4.57Zm0-13.72h1.52V6.1H4.57ZM3.05 6.1h1.52v12.19H3.05Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialLightBulb
